import React from 'react';
import {Button, Result} from 'antd';
import {useNavigate} from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page. You need 'read' permission to view this content."
        extra={[
          <Button type="primary" key="home" onClick={handleGoHome}>
            Go Home
          </Button>,
          <Button key="back" onClick={handleGoBack}>
            Go Back
          </Button>,
        ]}
      />
    </div>
  );
};

export default Unauthorized;
